module.exports = __webpack_public_path__ + "img/tikr-dark.bfc071c8.png";